<script setup lang="ts">
import { StoryblokComponent } from '@storyblok/vue'
import type { StoryblokAsset } from '../../types'

interface Props {
  blok: {
    logo: StoryblokAsset
    socials?: any[]
    lists?: any[]
    copyright: string
  }
}
defineProps<Props>()

const theme = useTheme()
</script>

<template>
  <div v-editable="blok" border-t :style="{ borderColor: theme.colors.spGray2 }">
    <div col gap="10 lg:15" class="px-[10px] lg:px-0 pb-5 pt-[30px] lg:pt-[40px]">
      <!-- Lists -->
      <div v-if="blok.lists?.length" max-w="1280px" w-full mx-auto flex="~ wrap <md:col" justify-between gap-3 md:gap-10 class="md:grid md:grid-cols-3 lg:flex">
        <StoryblokComponent v-for="list in blok.lists" :key="list._uid" :blok="list" />
      </div>

      <!-- Logo and Socials -->
      <div class="flex flex-col flex-wrap gap-5 max-w-1280px w-full mx-auto pt-6 lg:pt-10" :style="{ borderTop: `1px solid ${theme.colors.spGray2}` }">
        <div class="max-w-165px">
          <img :src="blok.logo.filename" :alt="blok.logo.alt">
        </div>

        <div v-if="blok.socials" class="flex items-center gap-2">
          <StoryblokComponent v-for="social in blok.socials" :key="social._uid" :blok="social" />
        </div>
      </div>
      <!-- Copyright -->
      <div class="max-w-1280px w-full mx-auto text-sm" :style="{ color: theme.colors.spGray3 }">
        <p>
          {{ blok.copyright }}
        </p>
      </div>
    </div>
  </div>
</template>
